import type { ConversationView } from '@hilo/contracts';

/**
 * Código corto y estable de un contacto, sacado de su ID interno de Hilo (nunca del PSID, IGSID ni teléfono).
 * Ayuda a distinguir a clientes sin nombre de perfil sin inventarles un nombre. Es solo una etiqueta: dos
 * contactos pueden coincidir en el código, así que no identifica a nadie ni sirve para buscar.
 */
export function contactCode(contactId: string): string {
  return contactId.replace(/-/g, '').slice(0, 4).toUpperCase();
}

/** Nombre del contacto; sin nombre de perfil, «Cliente» y su código (nunca el teléfono ni un nombre inventado). */
export function contactName(conversation: Pick<ConversationView, 'contactDisplayName' | 'contactId'>): string {
  const name = conversation.contactDisplayName?.trim();
  return name ? name : `Cliente ${contactCode(conversation.contactId)}`;
}

/** true si el canal no facilitó nombre de perfil (se muestra el alternativo). */
export function isUnnamed(conversation: Pick<ConversationView, 'contactDisplayName'>): boolean {
  return !conversation.contactDisplayName?.trim();
}
